import { z } from 'zod'

import { cmsIdSchema } from '../cms.ids'
import { resolvedMediaSchema } from '../cms.media'
import { BlockType } from './types'

/**
 * The skeleton every block shares. `id` is stable across locales and reorders — that is what lets
 * the admin mutate block structure for every locale at once, and what lets a `block:<id>` in-page
 * anchor resolve in every language.
 *
 * Fields are near-universally permissive (`z.string()`, not `z.string().nonempty()`) because a
 * half-authored block must still save as a draft. Renderers handle emptiness by not rendering.
 * Strictness lives at the page level, keyed off publish intent.
 */
export const blockOf = <T extends BlockType>(type: T) => ({
    id: cmsIdSchema,
    type: z.literal(type),
    order: z.number().int(),
})

/** One row of a repeatable sub-list: hero slides, cards, table rows, timeline years. */
export const subListItemOf = () => ({
    id: cmsIdSchema,
    order: z.number().int(),
})

/**
 * A media slot stores only the id; the api attaches the resolved sibling at read time and strips
 * it back off before persisting.
 */
export const mediaIdSchema = cmsIdSchema.nullish()

export const mediaSchema = resolvedMediaSchema.nullish()
